import styled from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';

const styles = (props) => {
  const sharedStyles = `
    align-items: center;
    background: transparent;
    display: flex;
    font-family: 'Titillium Web', sans-serif;
    justify-content: center;
    margin: 0 0 0 15px;
    padding: 5px 20px;
    text-decoration: none !important;
    transition: all .1s ease-out;
    width: auto;

    &:hover {
      border-color: transparent;
    }

    ${
      props.block
        ? `
        margin: 0;
        padding: 10px 0;
        text-align: center;
        width: 100%;
      `
        : ''
    }

    ${props.squared ? 'border-radius: 8px;' : 'border-radius: 50px;'}

    ${
      props.rounded
        ? `
        border-radius: 50%;
        height: 45px;
        margin: 0;
        padding: 0;
        width: 45px;
      `
        : ''
    }

    ${props.small ? 'font-size: .75rem;' : 'font-size: 1rem;'}
  `;

  switch (props.variant) {
    case 'primary':
      return `
        ${sharedStyles}
        background: rgb(158, 13, 61);
        border-color: rgb(158, 13, 61);
        color: #fff !important;

        &:hover {
          background: rgb(127, 7, 39);
        }
      `;
    case 'secondary':
      return `
        ${sharedStyles}
        background: rgb(253, 177, 47);
        font-weight: 600;
        color: #262626 !important;

        &:hover {
          background: rgb(238, 151, 2);
        }
      `;
    case 'light':
      return `
        ${sharedStyles}
        &:hover {
          color: rgb(253, 177, 47) !important;
          border-color: transparent;
        }
      `;
    case 'minimal':
      return `
        ${sharedStyles}
        color: rgb(77, 92, 109);
        margin: 0;
        padding: 0;

        &:hover {
          color: rgb(238, 151, 2) !important;
        }
      `;
    default:
      return sharedStyles;
  }
};

const StyledAnchor = styled.a`
  ${styles}
`;

const StyledLink = styled(RouterLink)`
  ${styles}
`;

const StyledButton = styled.button`
  ${styles}
  border: none;
`;

export const ButtonLink = ({
  to,
  label,
  block,
  squared,
  rounded,
  onClick,
  children,
  small,
  external = false,
  variant = 'default',
  target = '_self',
  disabled,
}) => {
  if (onClick) {
    return (
      <StyledButton
        onClick={onClick}
        variant={variant}
        squared={squared}
        block={block}
        rounded={rounded}
        disabled={disabled}
      >
        {label || children}
      </StyledButton>
    );
  }

  if (external) {
    return (
      <StyledAnchor
        href={to}
        variant={variant}
        squared={squared}
        block={block}
        rounded={rounded}
        small={small}
        target={target}
      >
        {label || children}
      </StyledAnchor>
    );
  }

  return (
    <StyledLink
      to={to}
      variant={variant}
      squared={squared}
      block={block}
      rounded={rounded}
      small={small}
      replace
    >
      {label || children}
    </StyledLink>
  );
};
